// 板块列表
export const topics = [
  { id: '574b1d64-45c6-4730-9c47-82e59fa74a51', englishName: 'used', name: '二手车' },
  { id: '9309b025-d488-4861-80b9-682be6cbb89d', englishName: 'lease', name: '转lease' },
];

// 板块映射
export const topicMapping = (function() {
  return topics.reduce((acc, topic) => ((acc[topic['englishName']] = topic), acc), {});
})(topics);

// 变速箱列表
export const gearBoxs = [
  { id: 0, name: '不限' },
  { id: 1, name: '手动' },
  { id: 2, name: '自动' },
];

// 燃油类型列表
export const fuelTypes = [
  { id: 0, name: '不限' },
  { id: 1, name: '汽油' },
  { id: 2, name: '柴油' },
  { id: 3, name: '电动' },
  { id: 4, name: '油电混合' },
];

// 驱动类型列表
export const drivingTypes = [
  { id: 0, name: '不限' },
  { id: 1, name: '前驱' },
  { id: 2, name: '后驱' },
  { id: 3, name: '四驱' },
  { id: 4, name: '全驱' },
];

// 车主身份列表
export const sources = [
  { id: 0, name: '不限' },
  { id: 1, name: '私车直售' },
  { id: 2, name: '车行专卖' },
];

// 年份列表
export const years = (function() {
  let startYear = new Date().getFullYear() + 1,
    endYear = 1999,
    //endYear = new Date().getFullYear() - 20,
    years = [];
  for (; startYear > endYear; startYear--) years.push({ id: startYear, name: `${startYear}年` });
  return years;
})();

// 剩余月数配置
export const lastTimeOptions = {
  min: 0,
  max: 66,
  step: 6,
  minLabel: '0',
  maxLabel: '60+',
};

// 剩余公里数配置
export const remainingKMOptions = {
  min: 0,
  max: 22,
  step: 2,
  minLabel: '0',
  maxLabel: '20+',
};

// 现有公里数配置
export const existingKMOptions = {
  min: 0,
  max: 22,
  step: 2,
  minLabel: '0',
  maxLabel: '20+',
};

/**
 * 根据未来的月数和当前日期计算未来的日期
 * @param {number} addMonth 添加的月数
 * @returns 由年份和月份组成6位数的日期字符串
 */
export function getYearMonth(addMonth) {
  const d = new Date();
  d.setMonth(d.getMonth() + addMonth);
  return `${d.getFullYear()}${(d.getMonth() + 1).toString().padStart(2, '0')}`;
}
